import React from 'react';
import { TopBarSkeletonSSR } from './top-bar-skeleton-ssr';
import { MastHeadMainBarSkeletonSSR, LogoData } from './masthead-main-bar-skeleton-ssr';
import { MegaMenuV2SkeletonSSR, MenuItemSSR } from './mega-menu-v2-skeleton-ssr';

export interface MastheadSkeletonSSRProps {
  /** Background color for the top bar (from SDM theme) */
  topBarBgColor?: string;
  /** Logo data from SDM header configuration */
  logo?: LogoData;
  /** Menu items from SDM header configuration */
  menuItems?: MenuItemSSR[];
}

/**
 * SSR-safe Masthead skeleton - composes individual SSR skeleton components.
 * This is a replica of the Chakra UI skeletons using pure inline styles.
 * Ensures identical visual display between SSR and client-side renders.
 *
 * The skeleton accepts SDM header data to display actual content (logo, menu labels)
 * where available, providing a better user experience during hydration.
 */
export const MastheadSkeletonSSR = ({
  topBarBgColor = '#c8102e',
  logo,
  menuItems,
}: MastheadSkeletonSSRProps) => {
  return (
    <div style={{ width: '100%' }} data-testid="masthead-skeleton-ssr">
      <TopBarSkeletonSSR containerBgColor={topBarBgColor} />
      <MastHeadMainBarSkeletonSSR logo={logo} />
      <MegaMenuV2SkeletonSSR menuItems={menuItems} />
    </div>
  );
};

MastheadSkeletonSSR.displayName = 'MastheadSkeletonSSR';
